export const ADD_BATCH_REQUEST = "ADD_BATCH_REQUEST";
export const ADD_BATCH_SUCCESS = "ADD_BATCH_SUCCESS";
export const ADD_BATCH_FAIL = "ADD_BATCH_FAIL";

export const FETCH_BATCH_REQUEST = "FETCH_BATCH_REQUEST";
export const FETCH_BATCH_SUCCESS = "FETCH_BATCH_SUCCESS";
export const FETCH_BATCH_FAIL = "FETCH_BATCH_FAIL";

// export const FETCH_BATCH_STATUS_REQUEST = "FETCH_BATCH_STATUS_REQUEST";
// export const FETCH_BATCH_STATUS_SUCCESS = "FETCH_BATCH_STATUS_SUCCESS";
// export const FETCH_BATCH_STATUS_FAIL = "FETCH_BATCH_STATUS_FAIL";

export const TOGGLE_BATCH_STATUS_REQUEST = "TOGGLE_BATCH_STATUS_REQUEST";
export const TOGGLE_BATCH_STATUS_SUCCESS = "TOGGLE_BATCH_STATUS_SUCCESS";
export const TOGGLE_BATCH_STATUS_FAIL = "TOGGLE_BATCH_STATUS_FAIL";

export const BATCH_ACTIVE_REQUEST = "BATCH_ACTIVE_REQUEST";
export const BATCH_ACTIVE_SUCCESS = "BATCH_ACTIVE_SUCCESS";
export const BATCH_ACTIVE_FAIL = "BATCH_ACTIVE_FAIL";

export const BATCH_INACTIVE_REQUEST = "BATCH_INACTIVE_REQUEST";
export const BATCH_INACTIVE_SUCCESS = "BATCH_INACTIVE_SUCCESS";
export const BATCH_INACTIVE_FAIL = "BATCH_INACTIVE_FAIL";